import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import TrustBar from "./components/TrustBar";
import About from "./components/About";
import Services from "./components/Services";
import Process from "./components/Process";
import Testimonials from "./components/Testimonials";
import Download from "./components/Download";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50 text-foreground-950 font-body">
      <Navbar />
      <Hero />
      <TrustBar />
      <About />
      <Services />
      <Process />
      <Testimonials />
      <Download />
      <Footer />
    </main>
  );
}